import { render, staticRenderFns } from "./tableList.vue?vue&type=template&id=b5a580ec&scoped=true"
import script from "./tableList.vue?vue&type=script&lang=js"
export * from "./tableList.vue?vue&type=script&lang=js"
import style0 from "./tableList.vue?vue&type=style&index=0&id=b5a580ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a580ec",
  null
  
)

export default component.exports